import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Componente para definir o título da página e meta descrição
 * 
 * @param {string} title - Título da página (será concatenado com o nome do site)
 * @param {string} description - Meta descrição da página (opcional)
 * @returns {JSX.Element} Componente Helmet com as tags title e meta
 */
const PageTitle = ({ title, description }) => {
  const fullTitle = title ? `${title} | Estudos Igreja de Jardim` : 'Estudos Igreja de Jardim';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};

export default PageTitle;
